const getters = {
  theme: state => state.app.themeColor
}

export default getters